import { translate, translationKeys } from '../translations/translations.service';

export const PHONE_VALIDATION_CODE_IS_NOT_VALID = translate(
  translationKeys.validator.form.phoneValidationCodeIsNotValid
);
export const VALIDATION_PHONE_CODE_LENGTH = 4;

export const isValidPhoneValidationCode = (code: string | undefined | null): string | undefined => {
  return code?.length === VALIDATION_PHONE_CODE_LENGTH
    ? undefined
    : PHONE_VALIDATION_CODE_IS_NOT_VALID;
};
